export default function Onboarding() {
  onboardingInit()
}

function onboardingInit() {
  const radioList = document.querySelectorAll(".onboarding__input-radio");

  if (radioList.length > 0) {
    radioList.forEach((radio) => {
      if (radio) {
        const radioId = radio.getAttribute("value");
        const checkbox = document.getElementById(`item_${radioId}`);
        if (checkbox) {
          radio.addEventListener("change", () => {
            const errorList = document.querySelector(".validation-summary-errors");
            if(errorList != null) {
                errorList.style.display = "none";
            }
            checkbox.checked = true;
          });
        }
      }
    });
  }

  const onboardingSubmitButton = document.querySelector(".onboarding__submit-button--dark");

  if (onboardingSubmitButton) {
    onboardingSubmitButton.addEventListener("click", () => {
      setTimeout(() => {
        const errorList = document.querySelector(".validation-summary-errors");

        if (errorList && errorList.style.display !== "none") {
          window.scrollTo({
            top: 0,
            left: 0,
            behavior: "smooth",
          });
        }
      }, 0);
    });
  }
}
